import { EffectType } from '../typings';

/** EffectType -> 类型名称 */
export const EffectTypeTextMap = /*#__PURE__*/(() => ({
  [EffectType.Formula]: '素材包',
  [EffectType.WordArt]: '花字',
  [EffectType.Sticker]: '贴纸',
  [EffectType.AudioEffect]: '音效',
  [EffectType.Music]: '音乐',
  [EffectType.TextTemplate]: '文字模板',
  [EffectType.Special]: '画面特效',
  [EffectType.FaceSpecial]: '人脸道具',
  [EffectType.Video]: '视频',
  [EffectType.Image]: '图片',
  [EffectType.WordArtCollection]: '花字合集',
  [EffectType.StickerCollection]: '贴纸合集',
  [EffectType.AudioEffectCollection]: '音效合集',
  [EffectType.VideoCollection]: '视频合集',
  [EffectType.Emoticon]: '系列表情',
  [EffectType.TextTemplateCollection]: '文字模板合集',
  [EffectType.Filter]: '滤镜',
  [EffectType.FilterCollection]: '滤镜合集'
}))();

/** EffectType -> 埋点用的类型名称 */
export const EffectTypeTextForLogMap = /*#__PURE__*/(() => ({
  [EffectType.Formula]: 'formula',
  [EffectType.Sticker]: 'sticker',
  [EffectType.AudioEffect]: 'sound_effect',
  [EffectType.WordArt]: 'text_special_effect',
  [EffectType.Music]: 'music',
  [EffectType.TextTemplate]: 'text_template',
  [EffectType.Special]: 'special_effect',
  [EffectType.FaceSpecial]: 'face_accessories',
  [EffectType.Video]: 'video',
  [EffectType.Image]: 'image',
  [EffectType.Emoticon]: 'emoji',
  [EffectType.Filter]: 'filter',
  [EffectType.FilterCollection]: 'filter_collection',
  [EffectType.WordArtCollection]: 'text_special_effect_collection',
  [EffectType.StickerCollection]: 'sticker_collection',
  [EffectType.AudioEffectCollection]: 'sound_effect_collection',
  [EffectType.VideoCollection]: 'video_collection',
  [EffectType.TextTemplateCollection]: 'text_template_collection'
}))();